import { useQuery } from '@apollo/client'
import { ActivityLogsDocument, ActivityLogsQueryVariables } from 'generated/resources/graphql'

export const useActivityLog = (variables?: ActivityLogsQueryVariables) => {
  const { data, loading, refetch } = useQuery(ActivityLogsDocument, {
    variables,
    fetchPolicy: 'network-only',
  })

  return {
    loading,
    logs: data?.activityLog.logsConnection.nodes || [],
    hasNextPage: data?.activityLog.logsConnection.pageInfo.hasNextPage ?? false,
    totalCount: data?.activityLog.logsConnection.totalCount || 0,
    refetch,
  }
}
